import React, { useState, useEffect } from "react";
import {
    Button,
    ButtonGroup,
    Card,
    CardHeader,
    CardBody,
    CardFooter,
    Form,
    FormGroup,
    Input,
    Label,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Spinner,
    Pagination,
} from "reactstrap";
import { toast } from 'react-toastify';
import { FaEye, FaPencilAlt, FaTrash, FaPlus, FaFilePdf, FaPrint, FaWhatsapp } from 'react-icons/fa';
import CustomTable from "../../components/CustomTable";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { apiURL1 } from '../../config';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import ReactPaginate from 'react-paginate';
import axios from 'axios';
import dayjs from 'dayjs';
import 'react-datepicker/dist/react-datepicker.css';
import Select from "react-select";
import html2canvas from 'html2canvas';


const baseURL = apiURL1;

const DonationInformation = () => {
    const token = localStorage.getItem("token");

    const [donations, setDonations] = useState([]);
    const [reportDonations, setReportDonations] = useState([]);

    const [newDonation, setNewDonation] = useState({
        donorId: "",
        categoryId: "",
        donationName: "",
        amount: "",
        date: "",
        purpose: "",
        notes: "",
        receiptNumber: "",
        isBank: false // Add this line


    });
    const [editDonation, setEditDonation] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [deleteDonationId, setDeleteDonationId] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [categories, setCategories] = useState([]);
    const [donors, setDonors] = useState([]);
    const [summary, setSummary] = useState(null);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [showSummary, setShowSummary] = useState(false);
    const [viewModalOpen, setViewModalOpen] = useState(false);
    const [viewDonation, setViewDonation] = useState(null);
    const [filter, setFilter] = useState({
        donorId: '',
        categoryId: '',
        from: '',
        to: '',
    });
    const [debouncedFilter, setDebouncedFilter] = useState(filter);
    const itemsPerPage = 10;
    const [loading, setLoading] = useState(false);
    const [madrasaInfo, setMadrasaInfo] = useState({});
    const [donorSearch, setDonorSearch] = useState('');
    const [categorySearch, setCategorySearch] = useState('');


    const filteredDonors = donors.filter(donor =>
        donor.name.toLowerCase().includes(donorSearch.toLowerCase())
    );
    const filteredCategories = categories.filter(category =>
        category.name.toLowerCase().includes(categorySearch.toLowerCase())
    );

    const donorOptions = filteredDonors.map(donor => ({
        value: donor._id,
        label: donor.name
    }));

    const categoryOptions = filteredCategories.map(category => ({
        value: category._id,
        label: category.name
    }));



    useEffect(() => {
        const timeoutId = setTimeout(() => {
            setDebouncedFilter(filter);
        }, 500);
        return () => clearTimeout(timeoutId);
    }, [filter]);

    useEffect(() => {
        fetchDonations();
        fetchReportDonations();
        fetchCategories();
        fetchDonors();
        fetchMadrasaInfo();
    }, [currentPage, debouncedFilter]);

    const fetchMadrasaInfo = async () => {
        try {
            const response = await axios.get(`${baseURL}/superadmin/school-settings`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            });
            const data = response.data;
            if (data && data.length > 0) {
                setMadrasaInfo(data[0]);
            }
        } catch (error) {
            console.error('Error fetching madrasa info:', error);
        }
    };

    const fetchDonations = async () => {
        setLoading(true);
        try {
            let url = `${baseURL}/superadmin/filterDonations?page=${currentPage}&limit=${itemsPerPage}`;
            const params = new URLSearchParams();
            if (debouncedFilter.categoryId) params.append('categoryId', debouncedFilter.categoryId);
            if (debouncedFilter.donorId) params.append('donorId', debouncedFilter.donorId);
            if (debouncedFilter.from) params.append('from', debouncedFilter.from);
            if (debouncedFilter.to) params.append('to', debouncedFilter.to);

            const paramString = params.toString();
            if (paramString) {
                url += `&${paramString}`;
            }

            const response = await axios(url, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            });
            const data = response.data;
            if (data && data.donations && Array.isArray(data.donations)) {
                setDonations(data.donations);
                setTotalPages(data.totalPages);
            } else {
                setDonations([]);
                setTotalPages(1);
            }
        } catch (error) {
            console.error('Error fetching donations:', error);
            toast.error('Error fetching donations!');
        } finally {
            setLoading(false);
        }
    };

    const fetchReportDonations = async () => {
        try {
            let url = `${baseURL}/superadmin/filterDonations`;



            const response = await axios(url, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            });
            const data = response.data;
            if (data && data.donations && Array.isArray(data.donations)) {
                console.log('report donations data:', data.donations);
                setReportDonations(data.donations);
            } else {
                setReportDonations([]);
            }
        } catch (error) {
            console.error('Error fetching donations:', error);
            toast.error('Error fetching donations!');
        } finally {
            setLoading(false);
        }
    };
    const fetchCategories = async () => {
        try {
            const response = await axios(`${baseURL}/superadmin/donation-categories`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            });
            const data = response.data;
            setCategories(data);
        } catch (error) {
            console.error('Error fetching categories:', error);
            toast.error('Error fetching categories!');
        }
    };

    const fetchDonors = async () => {
        try {
            const response = await axios(`${baseURL}/superadmin/get-donor-info`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            });
            const data = response.data;
            setDonors(data);
        } catch (error) {
            console.error('Error fetching donors:', error);
            toast.error('Error fetching donors!');
        }
    };

    const handleAddDonation = async (e) => {
        e.preventDefault();
        try {
            const response = await axios(`${baseURL}/superadmin/donations`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    'Authorization': `Bearer ${token}`,
                },
                data: JSON.stringify(newDonation),
            });
            if (response.status === 200) {
                toast.success("Donation added successfully!");
                fetchDonations();
                setNewDonation({
                    donorId: "",
                    categoryId: "",
                    donationName: "",
                    amount: "",
                    date: "",
                    purpose: "",
                    notes: "",
                    receiptNumber: ""
                });
                setModalOpen(false);
            } else {
                toast.error("Error adding donation!");
            }
        } catch (error) {
            console.error("Error adding donation:", error);
            toast.error("Error adding donation!");
        }
    };

    const handleEditDonation = (donation) => {
        setEditDonation({
            ...donation,
            donorId: donation.donorId?._id || '',
            categoryId: donation.categoryId?._id || '',
            date: dayjs(donation.date).format('YYYY-MM-DD') || '',
            isBank: donation.isBank || false
        });
        setEditModalOpen(true);
    };

    const handleUpdateDonation = async (e) => {
        e.preventDefault();
        try {
            const response = await axios(`${baseURL}/superadmin/donations/${editDonation._id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    'Authorization': `Bearer ${token}`,
                },
                data: JSON.stringify(editDonation),
            });
            if (response.status === 200) {
                toast.success("Donation updated successfully!");
                fetchDonations();
                setEditDonation(null);
                setEditModalOpen(false);
            } else {
                toast.error("Error updating donation!");
            }
        } catch (error) {
            console.error("Error updating donation:", error);
            toast.error("Error updating donation!");
        }
    };

    const handleDeleteDonation = (id) => {
        setDeleteDonationId(id);
        setDeleteModalOpen(true);
    };

    const confirmDeleteDonation = async () => {
        try {
            const response = await axios(`${baseURL}/superadmin/donations/${deleteDonationId}`, {
                method: "DELETE",
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            });
            if (response.status === 200) {
                toast.success("Donation deleted successfully!");
                fetchDonations();
            } else {
                toast.error("Error deleting donation!");
            }
        } catch (error) {
            console.error("Error deleting donation:", error);
            toast.error("Error deleting donation!");
        } finally {
            setDeleteModalOpen(false);
            setDeleteDonationId(null);
        }
    };

    const handlePageChange = (selectedPage) => {
        setCurrentPage(selectedPage.selected + 1);
    };

    const fetchSummary = async () => {
        try {
            const response = await axios(`${baseURL}/superadmin/donations/summary?startDate=${startDate}&endDate=${endDate}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            });
            const data = response.data;
            setSummary(data);
        } catch (error) {
            console.error('Error fetching summary:', error);
            toast.error('Error fetching summary!');
        }
    };

    const renderSummaryChart = () => {
        if (!summary || !summary.categorySummary || summary.categorySummary.length === 0) {
            return <p>No summary data available.</p>;
        }

        const data = summary.categorySummary.map(item => ({
            name: item.categoryName,
            amount: item.totalAmount,
        }));

        return (
            <ResponsiveContainer width="100%" height={300}>
                <BarChart data={data}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Bar dataKey="amount" fill="#8884d8" />
                </BarChart>
            </ResponsiveContainer>
        );
    };

    const handleViewDonation = (donation) => {
        setViewDonation(donation);
        setViewModalOpen(true);
    };

    const handleFilterChange = (e) => {
        setFilter({ ...filter, [e.target.name]: e.target.value });
    };

    const applyFilters = () => {
        setCurrentPage(1);
        fetchDonations();
    };

    const toggleSummaryView = () => {
        setShowSummary(!showSummary);
    };

    const formatDate = (dateStr) => {
        // console.log('formatDate called with dateStr:', dateStr, 'Type:', typeof dateStr);
        if (!dateStr || typeof dateStr !== 'string' || dateStr.trim() === '') {
            // console.error('Invalid dateStr input:', dateStr);
            return 'Invalid Date';
        }
        const d = new Date(dateStr);
        if (!(d instanceof Date) || isNaN(d.getTime())) {
            // console.error('Invalid Date object created from:', dateStr);
            return 'Invalid Date';
        }
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };


    const generateReport = () => {
        const doc = new jsPDF();
        const pageWidth = doc.internal.pageSize.getWidth();

        // School Logo and Information (Header)
        const img = new Image();
        img.src = "https://res.cloudinary.com/djg7v9dna/image/upload/v1742946371/mi0wavjsehps20kdzaet.png";

        doc.addImage(img, 'PNG', 15, 15, 30, 30);

        doc.setFontSize(16);
        doc.setFont('helvetica', 'bold');
        doc.text(madrasaInfo.schoolName || 'Madrasa Name', 50, 22);
        doc.setFontSize(10);
        doc.setFont('helvetica', 'normal');
        doc.text(madrasaInfo.schoolAddress || 'Madrasa Address', 50, 28);
        doc.text(`Tel: ${madrasaInfo.schoolPhoneNumber || 'Phone'} | Email: ${madrasaInfo.schoolEmail || 'Email'}`, 50, 34);

        // Report Title
        doc.setFontSize(18);
        doc.text('Donation Information Report', pageWidth / 2, 55, { align: 'center' });

        // Define the columns for the table
        const columns = ["Receipt Number", "Donor Name", "Donation Amount", "Donation Date", "Category", " Bank/Cash"];

        // Prepare the data for the table


        const data = reportDonations.map(donation => [
            donation.receiptNumber || 'N/A',
            donation.donorId?.name || 'N/A',
            donation.amount,
            formatDate(donation.date),
            donation.categoryId?.name || 'N/A',
            donation.isBank ? 'BANK' : 'CASH'
        ]);

        // Add the table to the PDF (reserve bottom margin so footer isn't alone on next page)
        doc.autoTable({
            startY: 65,
            head: [columns],
            body: data,
            styles: { fontSize: 8, cellPadding: 2, overflow: 'linebreak' },
            headStyles: { fillColor: [41, 128, 185], textColor: 255, fontSize: 8 },
            margin: { left: 12, right: 12, bottom: 18 },
        });

        const totalPages = doc.getNumberOfPages();
        for (let i = 1; i <= totalPages; i++) {
            doc.setPage(i);
            doc.setFontSize(7);
            doc.setTextColor(80, 80, 80);
            doc.text(
                `Generated on: ${new Date().toLocaleDateString()} | ${madrasaInfo.schoolName || 'Madrasa Name'}`,
                pageWidth / 2,
                doc.internal.pageSize.getHeight() - 8,
                { align: 'center' }
            );
        }

        doc.save('donations_report.pdf');
    };

    const printDonation = (donation) => {
        // console.log('donation is ', donation)
        const receiptNumber = donation.receiptNumber || 'N/A';
        const date = formatDate(donation.date) || 'N/A';
        const donorName = donation.donorId?.name || 'N/A';
        const category = donation.categoryId?.name || 'N/A';
        const amount = donation.amount || 'N/A';
        const paymentMethod = donation.isBank ? 'BANK' : 'CASH';
        const purpose = donation.purpose || 'N/A';
        const notes = donation.notes || '';
        const amountInWordsText = isNaN(amount) ? amount : amountInWords(parseInt(amount));
        let checkoutBy = 'N/A';
        try {
            const ui = localStorage.getItem('userInfo');
            checkoutBy = (ui && JSON.parse(ui)?.name) || 'N/A';
        } catch (e) { console.error(e); }

        const printContent = `
<!DOCTYPE html>
<html>
<head>
    <title>Donation Receipt</title>
    <style>
        @page { size: A5; margin: 8mm; }
        * { box-sizing: border-box; }
        body {
            margin: 0;
            padding: 0;
            font-family: sans-serif;
            font-size: 12px;
            color: #000;
        }
        .receipt-container {
            width: 100%;
            max-width: 132mm;
            margin: 0 auto;
            page-break-inside: avoid;
        }
        .header { text-align: center; margin-bottom: 8px; }
        .header img { width: 56px; height: 56px; margin-bottom: 4px; }
        .header h2 { margin: 2px 0; font-size: 14px; }
        .header h3 { margin: 6px 0 2px; font-size: 13px; }
        .header p { margin: 1px 0; font-size: 10px; }
        .header hr { border: 0; border-top: 0.5px solid #000; margin: 6px 0; }
        .row { display: flex; justify-content: space-between; gap: 8px; margin: 4px 0; }
        .field { margin: 4px 0; font-size: 12px; }
        .field span { border-bottom: 1px solid #000; display: inline-block; min-width: 40px; }
        .sigs {
            display: flex; justify-content: space-between; margin-top: 18px;
            page-break-inside: avoid;
        }
        .sig { text-align: center; min-width: 110px; }
        .sig-line { border-top: 1px solid #000; margin-top: 22px; padding-top: 4px; font-size: 11px; }
        .footer { text-align: center; margin-top: 10px; font-size: 10px; page-break-inside: avoid; }
        .footer hr { border: 0; border-top: 0.5px solid #000; margin: 8px 0; }
    </style>
</head>
<body>
    <div class="receipt-container">
        <div class="header">
            <img src="https://res.cloudinary.com/djg7v9dna/image/upload/v1739198257/Logo/kgamz0yjfr9uy8dsbnur.webp" alt="Madrasa Logo">
            <h2>${madrasaInfo.schoolName || 'N/A'}</h2>
            <p>${madrasaInfo.schoolAddress || 'N/A'}</p>
            <p>Phone: ${madrasaInfo.schoolPhoneNumber || 'N/A'} | Email: ${madrasaInfo.schoolEmail || 'N/A'}</p>
            <hr>
            <h3>DONATION RECEIPT</h3>
        </div>

        <div class="row">
            <p class="field" style="margin:0;"><strong>Receipt No:</strong> <span>${receiptNumber}</span></p>
            <p class="field" style="margin:0;"><strong>Date:</strong> <span>${date}</span></p>
        </div>
        <div class="row">
            <p class="field" style="margin:0;"><strong>Donor:</strong> <span>${donorName}</span></p>
            <p class="field" style="margin:0;"><strong>Category:</strong> <span>${category}</span></p>
        </div>
        <p class="field"><strong>Amount in Words:</strong> <span>${amountInWordsText}</span></p>
        <div class="row">
            <p class="field" style="margin:0;"><strong>Amount:</strong> <span>${amount}</span></p>
            <p class="field" style="margin:0;"><strong>Method:</strong> <span>${paymentMethod}</span></p>
        </div>
        <p class="field"><strong>Purpose:</strong> <span>${purpose}</span></p>
        <p class="field"><strong>Notes:</strong> <span>${notes || 'N/A'}</span></p>

        <div class="sigs">
            <div class="sig"><div class="sig-line"><strong>Received By</strong></div></div>
            <div class="sig"><div class="sig-line"><strong>Checked By</strong></div></div>
            <div class="sig"><div class="sig-line"><strong>Approved By</strong></div></div>
        </div>

        <div class="footer">
            <hr>
            <p style="margin:2px 0;"><strong>Bank A/C No.</strong> 001-0139340001</p>
            <p style="margin:2px 0;">Amana Bank, Akkaraipattu</p>
        </div>
    </div>
    <script>
        window.onload = function() { window.print(); }
    </script>
</body>
</html>
    `;

        const printWindow = window.open('', '', 'width=560,height=800');
        printWindow.document.write(printContent);
        printWindow.document.close();
    };

    const sendWhatsAppDonation = async (donation) => {
        try {
            const receiptNumber = donation.receiptNumber || 'N/A';
            const date = formatDate(donation.date) || 'N/A';
            const donorName = donation.donorId?.name || 'N/A';
            const category = donation.categoryId?.name || 'N/A';
            const amount = donation.amount || 'N/A';
            const paymentMethod = donation.isBank ? 'BANK' : 'CASH';
            const purpose = donation.purpose || 'N/A';
            const notes = donation.notes || '';
            const amountInWordsText = isNaN(Number(amount)) ? amount : amountInWords(parseInt(amount));

            const buildReceiptElement = () => {
                const container = document.createElement('div');
                container.style.width = '700px';
                container.style.padding = '20px';
                container.style.background = '#fff';
                container.style.color = '#000';
                container.style.fontFamily = 'sans-serif';
                container.style.lineHeight = '1.4';
                container.style.boxSizing = 'border-box';
                container.innerHTML = `
                  <div style="text-align:center; margin-bottom: 10px;">
                    <img src="https://res.cloudinary.com/djg7v9dna/image/upload/v1739198257/Logo/kgamz0yjfr9uy8dsbnur.webp" alt="Madrasa Logo" style="width:80px;height:80px;margin-bottom:10px;" />
                    <h2 style="margin:5px 0; font-size:16px;">${madrasaInfo.schoolName || 'N/A'}</h2>
                    <p style="margin:2px 0; font-size:12px;">${madrasaInfo.schoolAddress || 'N/A'}</p>
                    <p style="margin:2px 0; font-size:12px;">Phone: ${madrasaInfo.schoolPhoneNumber || 'N/A'} | Email: ${madrasaInfo.schoolEmail || 'N/A'}</p>
                    <hr style="border: 0.5px solid #000; margin: 10px 0;"/>
                    <h3 style="margin:10px 0; font-size:15px;">DONATION RECEIPT</h3>
                  </div>
                  <div style="text-align:right; margin-bottom: 10px; font-size:13px;">
                    <p style="margin:4px 0;"><strong>Receipt Number:</strong> <span style="border-bottom:1px solid #000;">${receiptNumber}</span></p>
                    <p style="margin:4px 0;"><strong>Date:</strong> <span style="border-bottom:1px solid #000;">${date}</span></p>
                  </div>
                  <div style="display:flex; justify-content:space-between; font-size:13px; margin-bottom:8px;">
                    <p style="margin:4px 0;"><strong>Donor Name:</strong> <span style="border-bottom:1px solid #000; display:inline-block; min-width: 300px;">${donorName}</span></p>
                    <p style="margin:4px 0;"><strong>Category:</strong> <span style="border-bottom:1px solid #000;">${category}</span></p>
                  </div>
                  <div style="font-size:13px; margin-bottom:8px;">
                    <p style="margin:4px 0;"><strong>Amount in Words:</strong> <span style="border-bottom:1px solid #000;">${amountInWordsText}</span></p>
                  </div>
                  <div style="margin-bottom:10px;">
                    <div style="display:flex; justify-content:space-between; font-size:13px;">
                      <p style="margin:4px 0;"><strong>Amount:</strong> <span style="border-bottom:1px solid #000;">${amount}</span></p>
                      <p style="margin:4px 0;"><strong>Payment Method:</strong> <span style="border-bottom:1px solid #000;">${paymentMethod}</span></p>
                    </div>
                  </div>
                  <div style="margin-top: 10px; font-size:13px;">
                    <p style="margin:4px 0;"><strong>Purpose:</strong> <span style="border-bottom:1px solid #000;">${purpose}</span></p>
                    <p style="margin:4px 0;"><strong>Received By:</strong></p>
                    <p style="margin: 4px 0; font-size: 16px">______________________</p>
                    <p style="margin:4px 0;"><strong>Notes:</strong> <span style="border-bottom:1px solid #000;">${notes}</span></p>
                    <hr style="border: 0.5px solid #000; margin: 10px 0;">
                    <p style="text-align:center; margin:4px 0;"><strong>Bank No:</strong> <span style="border-bottom:1px solid #000;">AAAA</span></p>
                    <p style="text-align:center; margin:4px 0;">AMNA BANK</p>
                  </div>
                `;
                return container;
            };

            const el = buildReceiptElement();
            document.body.appendChild(el);
            let blob;
            try {
                const canvas = await html2canvas(el, { scale: 2, useCORS: true, backgroundColor: '#ffffff' });
                blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/png'));
            } finally {
                document.body.removeChild(el);
            }
            if (!blob) {
                const text = `Donation Receipt\nDonor: ${donorName}\nReceipt: ${receiptNumber}\nDate: ${date}\nAmount: ${amount} (${amountInWordsText})`;
                const encoded = encodeURIComponent(text);
                const isMobile = /Android|iPhone|iPad/i.test(navigator.userAgent);
                if (!isMobile) {
                    const appUrl = `whatsapp://send?text=${encoded}`;
                    const win = window.open(appUrl, '_blank', 'noopener,noreferrer');
                    if (!win) {
                        window.open(`https://web.whatsapp.com/send?text=${encoded}`);
                    }
                } else {
                    window.open(`https://api.whatsapp.com/send?text=${encoded}`, '_blank', 'noopener,noreferrer');
                }
                return;
            }

            if (navigator.canShare && typeof File !== 'undefined') {
                const file = new File([blob], `donation-${receiptNumber}.png`, { type: 'image/png' });
                if (navigator.canShare({ files: [file] })) {
                    await navigator.share({ files: [file], text: 'Donation Receipt' });
                    return;
                }
            }

            try {
                if (navigator.clipboard && window.ClipboardItem) {
                    const item = new ClipboardItem({ 'image/png': blob });
                    await navigator.clipboard.write([item]);
                }
            } catch (e) { console.error(e); }

            toast.success('Receipt image copied. Choose a chat in WhatsApp and paste.');
            const win = window.open('whatsapp://send', '_blank', 'noopener,noreferrer');
            if (!win) window.open('https://web.whatsapp.com/');
        } catch (error) {
            console.error('WhatsApp share error:', error);
            toast.error('Failed to open WhatsApp');
        }
    };

    const amountInWords = (num) => {
        // console.log('num is', num);

        const ones = [
            "", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine"
        ];
        const teens = [
            "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"
        ];
        const tens = [
            "", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"
        ];

        if (num === 0) return "Zero";
        if (isNaN(num)) return "Invalid Amount";

        let words = "";

        // Handle lakhs (100,000s)
        if (num >= 100000) {
            const lakhsValue = Math.floor(num / 100000);
            words += convertTwoDigits(lakhsValue) + " Lakh ";
            num %= 100000;
        }

        // Handle thousands
        if (num >= 1000) {
            const thousandsValue = Math.floor(num / 1000);
            words += convertTwoDigits(thousandsValue) + " Thousand ";
            num %= 1000;
        }

        // Handle hundreds
        if (num >= 100) {
            words += ones[Math.floor(num / 100)] + " Hundred ";
            num %= 100;
        }

        // Handle remaining tens and ones
        if (num > 0) {
            // Add "and" after hundreds or thousands if there are remaining digits
            if (words.length > 0) {
                words += "and ";
            }
            words += convertTwoDigits(num);
        }

        return words.trim();

        // Helper function to convert two-digit numbers
        function convertTwoDigits(n) {
            if (n === 0) return "";
            if (n < 10) return ones[n];
            if (n >= 10 && n < 20) return teens[n - 10];

            const tensDigit = Math.floor(n / 10);
            const onesDigit = n % 10;

            if (onesDigit === 0) return tens[tensDigit];
            return tens[tensDigit] + " " + ones[onesDigit];
        }
    };


    const columns = [
        "Receipt Number",
        "Donor Name",
        "Donation Amount",
        "Donation Date",
        "Category",
        "Bank/Cash",

        "Actions"
    ];

    const rows = donations ? donations.map(donation => ({
        receiptNumber: donation.receiptNumber || 'N/A',
        donorName: donation.donorId?.name || 'N/A',
        donationAmount: donation.amount,
        donationDate: formatDate(donation.date),
        category: donation.categoryId?.name || 'N/A',
        bankCash: donation.isBank ? 'BANK' : 'CASH',
        actions: (
            <ButtonGroup size="sm" className="flex-nowrap">
                <Button
                    color="info"
                    size="sm"
                    title="View"
                    className="d-inline-flex align-items-center justify-content-center px-2"
                    onClick={() => handleViewDonation(donation)}
                >
                    <FaEye />
                </Button>
                <Button
                    color="primary"
                    size="sm"
                    title="Edit"
                    className="d-inline-flex align-items-center justify-content-center px-2"
                    onClick={() => handleEditDonation(donation)}
                >
                    <FaPencilAlt />
                </Button>
                <Button
                    color="danger"
                    size="sm"
                    title="Delete"
                    className="d-inline-flex align-items-center justify-content-center px-2"
                    onClick={() => handleDeleteDonation(donation._id)}
                >
                    <FaTrash />
                </Button>
                <Button
                    color="secondary"
                    size="sm"
                    title="Print"
                    className="d-inline-flex align-items-center justify-content-center px-2"
                    onClick={() => printDonation(donation)}
                >
                    <FaPrint />
                </Button>
                <Button
                    color="success"
                    size="sm"
                    title="Share WhatsApp"
                    className="d-inline-flex align-items-center justify-content-center px-2"
                    onClick={() => sendWhatsAppDonation(donation)}
                >
                    <FaWhatsapp />
                </Button>
            </ButtonGroup>
        )
    })) : [];

    return (
        <>
            <Card>
                <CardHeader className="d-flex justify-content-between align-items-center flex-wrap" style={{ gap: '8px' }}>
                    <h3 className="mb-0">Donation Information</h3>
                    <div className="d-flex flex-wrap align-items-center" style={{ gap: '8px' }}>
                        <Button color="secondary" size="sm" onClick={toggleSummaryView}>
                            {showSummary ? 'View Donations' : 'View Summary'}
                        </Button>
                        <Button color="primary" size="sm" className="d-inline-flex align-items-center" onClick={() => setModalOpen(true)}>
                            <FaPlus className="mr-1" /> Add New
                        </Button>
                        <Button color="info" size="sm" className="d-inline-flex align-items-center" onClick={generateReport}>
                            <FaFilePdf className="mr-1" /> Generate Report
                        </Button>
                    </div>
                </CardHeader>
                <CardBody>
                    {!showSummary ? (
                        <>
                            <div className="d-flex align-items-center mb-3 flex-wrap" style={{ gap: '8px' }}>
                                <Input
                                    bsSize="sm"
                                    type="select"
                                    name="donorId"
                                    value={filter.donorId}
                                    onChange={handleFilterChange}
                                    style={{ width: '200px' }}
                                >
                                    <option value="">Select Donor</option>
                                    {donors.map((donor) => (
                                        <option key={donor._id} value={donor._id}>{donor.name}</option>
                                    ))}
                                </Input>
                                <Input
                                    bsSize="sm"
                                    type="select"
                                    name="categoryId"
                                    value={filter.categoryId}
                                    onChange={handleFilterChange}
                                    style={{ width: '200px' }}
                                >
                                    <option value="">Select Category</option>
                                    {categories.map((category) => (
                                        <option key={category._id} value={category._id}>{category.name}</option>
                                    ))}
                                </Input>
                                <span className="text-sm mb-0">Start Date:</span>
                                <Input
                                    bsSize="sm"
                                    type="date"
                                    name="from"
                                    value={filter.from}
                                    onChange={handleFilterChange}
                                    style={{ width: '150px' }}
                                />
                                <span className="text-sm mb-0">End Date:</span>
                                <Input
                                    bsSize="sm"
                                    type="date"
                                    name="to"
                                    value={filter.to}
                                    onChange={handleFilterChange}
                                    style={{ width: '150px' }}
                                />
                                <Button color="primary" size="sm" onClick={applyFilters}>
                                    Apply Filters
                                </Button>
                            </div>
                            {loading ? (
                                <div className="text-center">
                                    <Spinner color="primary" />
                                </div>
                            ) : (
                                <CustomTable columns={columns} rows={rows} />
                            )}
                        </>
                    ) : (
                        <>
                            <div className="d-flex align-items-center flex-wrap mt-3" style={{ gap: '8px' }}>
                                <Label className="mb-0">Start Date:</Label>
                                <Input
                                    bsSize="sm"
                                    type="date"
                                    value={startDate}
                                    onChange={(e) => setStartDate(e.target.value)}
                                    style={{ width: '150px' }}
                                />
                                <Label className="mb-0">End Date:</Label>
                                <Input
                                    bsSize="sm"
                                    type="date"
                                    value={endDate}
                                    onChange={(e) => setEndDate(e.target.value)}
                                    style={{ width: '150px' }}
                                />
                                <Button color="primary" size="sm" onClick={fetchSummary}>
                                    Get Summary
                                </Button>
                            </div>
                            {summary && (
                                <div className="mt-4">
                                    <p><strong>Total Donations:</strong> {summary.totalDonations}</p>
                                    <p><strong>Total Amount:</strong> {summary.totalAmount}</p>
                                    {renderSummaryChart()}
                                </div>
                            )}
                        </>
                    )}
                </CardBody>
                <CardFooter className="py-4">
                    <nav aria-label="...">
                        <Pagination
                            className="pagination justify-content-end mb-0"
                            listClassName="justify-content-end mb-0"
                        >
                            <ReactPaginate
                                previousLabel={
                                    <i
                                        className="previous fa fa-chevron-left"
                                        aria-hidden="true"
                                    ></i>
                                }
                                nextLabel={
                                    <i
                                        className="next fa fa-chevron-right"
                                        aria-hidden="true"
                                    ></i>
                                }
                                breakLabel={"..."}
                                pageCount={totalPages}
                                onPageChange={handlePageChange}
                                containerClassName={"pagination justify-content-end mb-0"}
                                pageClassName={"page-item"}
                                pageLinkClassName={"page-link"}
                                activeClassName={"active"}
                                previousClassName={"page-item"}
                                nextClassName={"page-item"}
                                previousLinkClassName={"page-link"}
                                nextLinkClassName={"page-link"}
                            />
                        </Pagination>
                    </nav>
                </CardFooter>
            </Card>
            <Modal isOpen={modalOpen} toggle={() => setModalOpen(false)}>
                <ModalHeader toggle={() => setModalOpen(false)}>Add Receipt Number</ModalHeader>
                <ModalBody>
                    <Form onSubmit={handleAddDonation}>


                        <FormGroup>
                            <Label>Donor</Label>
                            <Select
                                options={donorOptions}
                                value={donorOptions.find(option => option.value === newDonation.donorId)}
                                onChange={(selectedOption) =>
                                    setNewDonation({ ...newDonation, donorId: selectedOption ? selectedOption.value : "" })
                                }
                                placeholder="Select Donor"
                                isClearable
                            />
                        </FormGroup>

                        <FormGroup>
                            <Label>Category</Label>
                            <Select
                                options={categoryOptions}
                                value={categoryOptions.find(option => option.value === newDonation.categoryId)}
                                onChange={(selectedOption) =>
                                    setNewDonation({ ...newDonation, categoryId: selectedOption ? selectedOption.value : "" })
                                }
                                placeholder="Select Category"
                                isClearable
                            />
                        </FormGroup>

                        <FormGroup>
                            <Label>Donation Name</Label>
                            <Input
                                type="text"
                                placeholder="Enter donation name"
                                value={newDonation.donationName}
                                onChange={(e) => setNewDonation({ ...newDonation, donationName: e.target.value })}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Amount</Label>
                            <Input
                                type="number"
                                placeholder="Enter donation amount"
                                value={newDonation.amount}
                                onChange={(e) => setNewDonation({ ...newDonation, amount: e.target.value })}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Date</Label>
                            <Input
                                type="date"
                                value={newDonation.date}
                                onChange={(e) => setNewDonation({ ...newDonation, date: e.target.value })}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Payment Method</Label>
                            <Input
                                type="select"
                                value={newDonation.isBank ? "bank" : "cash"}
                                onChange={(e) => setNewDonation({
                                    ...newDonation,
                                    isBank: e.target.value === "bank"
                                })}
                            >
                                <option value="cash">Cash</option>
                                <option value="bank">Bank</option>
                            </Input>
                        </FormGroup>

                        <FormGroup>
                            <Label>Purpose</Label>
                            <Input
                                type="text"
                                placeholder="Enter donation purpose"
                                value={newDonation.purpose}
                                onChange={(e) => setNewDonation({ ...newDonation, purpose: e.target.value })}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Notes</Label>
                            <Input
                                type="textarea"
                                placeholder="Enter notes"
                                value={newDonation.notes}
                                onChange={(e) => setNewDonation({ ...newDonation, notes: e.target.value })}
                            />
                        </FormGroup>
                        <Button color="primary" type="submit">
                            Add Donation
                        </Button>
                    </Form>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={() => setModalOpen(false)}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={editModalOpen} toggle={() => setEditModalOpen(false)}>
                <ModalHeader toggle={() => setEditModalOpen(false)}>Edit Donation</ModalHeader>
                <ModalBody>
                    <Form onSubmit={handleUpdateDonation}>
                        <FormGroup>
                            <Label>Receipt Number</Label>
                            <Input
                                type="text"
                                placeholder="Enter Receipt Number"
                                value={editDonation?.receiptNumber}
                                readOnly
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Donor</Label>
                            <Select
                                options={donorOptions}
                                value={donorOptions.find(option => option.value === editDonation?.donorId)}
                                onChange={(selectedOption) =>
                                    setEditDonation({ ...editDonation, donorId: selectedOption ? selectedOption.value : "" })
                                }
                                placeholder="Select Donor"
                                isClearable
                                isSearchable
                            />
                        </FormGroup>

                        <FormGroup>
                            <Label>Category</Label>
                            <Select
                                options={categoryOptions}
                                value={categoryOptions.find(option => option.value === editDonation?.categoryId)}
                                onChange={(selectedOption) =>
                                    setEditDonation({ ...editDonation, categoryId: selectedOption ? selectedOption.value : "" })
                                }
                                placeholder="Select Category"
                                isClearable
                                isSearchable
                            />
                        </FormGroup>

                        <FormGroup>
                            <Label>Donation Name</Label>
                            <Input
                                type="text"
                                placeholder="Enter donation name"
                                value={editDonation?.donationName}
                                onChange={(e) => setEditDonation({ ...editDonation, donationName: e.target.value })}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Amount</Label>
                            <Input
                                type="number"
                                placeholder="Enter donation amount"
                                value={editDonation?.amount}
                                onChange={(e) => setEditDonation({ ...editDonation, amount: e.target.value })}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Date</Label>
                            <Input
                                type="date"
                                value={editDonation?.date}
                                onChange={(e) => setEditDonation({ ...editDonation, date: e.target.value })}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Payment Method</Label>
                            <Input
                                type="select"
                                value={editDonation?.isBank ? "bank" : "cash"}
                                onChange={(e) => setEditDonation({
                                    ...editDonation,
                                    isBank: e.target.value === "bank"
                                })}
                            >
                                <option value="cash">Cash</option>
                                <option value="bank">Bank</option>
                            </Input>
                        </FormGroup>

                        <FormGroup>
                            <Label>Purpose</Label>
                            <Input
                                type="text"
                                placeholder="Enter donation purpose"
                                value={editDonation?.purpose}
                                onChange={(e) => setEditDonation({ ...editDonation, purpose: e.target.value })}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Notes</Label>
                            <Input
                                type="textarea"
                                placeholder="Enter notes"
                                value={editDonation?.notes}
                                onChange={(e) => setEditDonation({ ...editDonation, notes: e.target.value })}
                            />
                        </FormGroup>
                        <Button color="primary" type="submit">
                            Update Donation
                        </Button>
                    </Form>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={() => setEditModalOpen(false)}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={deleteModalOpen} toggle={() => setDeleteModalOpen(false)}>
                <ModalHeader toggle={() => setDeleteModalOpen(false)}>Delete Donation</ModalHeader>
                <ModalBody>
                    <p>Are you sure you want to delete this donation?</p>
                </ModalBody>
                <ModalFooter>
                    <Button color="danger" onClick={confirmDeleteDonation}>
                        Yes, Delete
                    </Button>
                    <Button color="secondary" onClick={() => setDeleteModalOpen(false)}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={viewModalOpen} toggle={() => setViewModalOpen(false)} size="lg">
                <ModalHeader toggle={() => setViewModalOpen(false)}>Donation Details</ModalHeader>
                <ModalBody style={{ overflowWrap: 'break-word' }}>
                    {viewDonation && (
                        <div>
                            <p><strong>Receipt Number:</strong> {viewDonation.receiptNumber}</p>
                            <p><strong>Donor:</strong> {viewDonation.donorId?.name}</p>
                            <p><strong>Category:</strong> {viewDonation.categoryId?.name}</p>
                            <p><strong>Donation Name:</strong> {viewDonation.donationName}</p>
                            <p><strong>Amount:</strong> {viewDonation.amount}</p>
                            <p>
                                <strong>Date:</strong>{' '}
                                {formatDate(viewDonation.date)}
                            </p>
                            <p><strong>Purpose:</strong> {viewDonation.purpose}</p>
                            <p><strong>Notes:</strong> {viewDonation.notes}</p>
                        </div>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={() => setViewModalOpen(false)}>
                        Close
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    );
};

export default DonationInformation;

